function ReturnDetails({loading,Skeleton,productDetails,Link}){

    return(

       <div className="root_return_details">
      {loading ? (
        <>
          <Skeleton height={50} width={"100%"} style={{ marginBottom: 10 }} />
          <Skeleton height={20} width={"80%"} />
        </>
      ) : (
        <>
          <div className="details_flx">
            <div>
              <img
                src="https://i.ibb.co/twnnXYxQ/truck.png"
                className="img-truck"
                alt="Free Shipping"
              />
              <span className="txt-sub-info-pdp">Free Shipping</span>
            </div>
            <div>
              <img
                src="https://i.ibb.co/PsNnXB2G/package.png"
                className="img-exchange"
                alt="Returns"
              />
              <span className="txt-sub-info-pdp">
                {productDetails?.return_exchange_days}
              </span>
            </div>
          </div>
          {productDetails?.sub_category_action_url === "carpet" ? (
            <p className="txt-Carpet-Finder">
              Not sure which carpet fits your space? Try our{" "}
              <span className="txt_crp">
                <Link to='/floor-matcher' target="_blank" rel="noopener noreferrer">Floor Matcher</Link>
              </span>
            </p>
          ) : null}
        </>
      )}
    </div>

    )

}
export default ReturnDetails;